export default {
  academicYears: [],
  sampleInventoryStatuses: [],
  regions: [],
  districts: [],
  schools: [],
  results: {
    items: [],
    pagination: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 1,
      count: 0,
      pageSize: 10,
    },
    dashboard: {
      counters: [],
      circleValue: 0,
    },
  },
  selectedRegion: null,
  selectedDistrict: null,
  selectedAcademicYear: null,
  selectedSchool: null,
  selectedStatus: null,
  canResearch: true,
};
